import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import { Mic, MicOff, Videocam, VideocamOff } from "@mui/icons-material";

const StreamAVController = ({
  connected,
  micEnabled,
  toggleMic,
  cameraEnabled,
  toggleCamera,
}) => {
  return (
    <div>
      {connected && (
        <Box display="flex" gap={2} alignItems="center">
          <Tooltip title={micEnabled ? "Mute Mic" : "Unmute Mic"}>
            <IconButton onClick={toggleMic} color="primary">
              {micEnabled ? <Mic /> : <MicOff color="error" />}
            </IconButton>
          </Tooltip>
          <Tooltip title={cameraEnabled ? "Turn Off Camera" : "Turn On Camera"}>
            <IconButton onClick={toggleCamera} color="primary">
              {cameraEnabled ? <Videocam /> : <VideocamOff color="error" />}
            </IconButton>
          </Tooltip>
        </Box>
      )}
    </div>
  );
};

export default StreamAVController;
